import Vue from 'vue'
import * as directives from './directives'

// 注册全局指令
const cameCase = (key) => {
  return key.replace(/([A-Z])/g, (a, b) => '-' + b.toLowerCase()).replace(/^-/, '')
}
Object.keys(directives).map(key => {
  // console.log(directives[key])
  // 这里的Key是LimitInput，转换后为limit-input
  // 注册指令时为limit-input，使用时要加前缀v。eg： v-limit-input
  Vue.directive(cameCase(key), directives[key])
})
